import useUserContext from "hooks/context-hooks/useUserContext";
import { useEffect, useState } from "react";
import { getOneSMSLog } from "services/messageService";

export const useGetOneSmsLog = (smsLogId: string | number | undefined) => {
  const [data, setData] = useState<SmsLog | null>(null);
  const [loading, setLoading] = useState<boolean>(!!smsLogId);
  const [error, setError] = useState<unknown>(null);

  const { token, officeId } = useUserContext();

  useEffect(() => {
    if (!smsLogId) return;
    const fetchSMSLog = async () => {
      try {
        setLoading(true);
        const response = await getOneSMSLog({ token, officeId }, smsLogId);
        setData(response.data.data as SmsLog);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSMSLog();
  }, [smsLogId]);

  return { data, loading, error };
};

export interface Office {
  id: string;
}

export interface GetSMSLogParams {
  token: string;
  current_office: Office;
}

type SmsLog = {
  id: string;
  from: string;
  to: string;
  ads_type_name: string;
  type_name: string;
  sms_status: string;
  body: string;
  created_at: string;
  sms_type_name: string;
  is_appointment_booked: boolean;
  type: string;
  patient_leads: {
    id: string;
    first_name: string;
    last_name: string | null;
    phone1: string;
    patient_status_name: string;
    country_id: string | null;
    email: string | null;
  }[];
  office: {
    id: string;
    name: string;
  };
};
